import { Switch } from "@mui/material"

interface Props {
    checked: boolean,
    onChange: any
}

export const InputSwitch = ({ checked, onChange }: Props) => {
    return (
        <Switch
            checked={checked}
            onChange={(ev) => {
                onChange(ev.target.checked)
            }}
        />
    )
}
